// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'My orders',
    pdf: 'PDF',
    detail: 'Detail',
    order_time: 'Order date',
    booking_number: 'Booking no',
    total: 'Ticket total',
    status: 'Status',
    status_open: 'Success',
    status_closed: 'Success',
    status_cancelled: "Cancelled",
    cancel: "Cancel",
    change: "Change",
    cancelled_at: "Cancelled",
    no_order: "You currently have no orders linked to your account."
}
